/**
 * HHT1 TimeLine Contents 정보
 * @type {string[]}
 */

export const HHT1_EP12_ANSWERS = [
    'Emma finds an old, deflated basketball.',
    'Luckily Mike has a pump at his house.',
    'Tony and his friends pump up the basketball at Mike’s house and start to play.',
    'While playing, the ball goes into the street.',
    'After looking for cars, Mike gets the ball and they continue to play.',
    'Mike shoots the ball, but it hits the rim and bounces onto the roof.',
    'Tony says he will go get the ball and climbs up on to the roof.',
    'On the roof, Tony finds the basketball.',
    'And he finds another basketball and a soccer ball.',
    'Ben asks if he can keep one of the balls, but Tony says it’s finders keepers. ',
    'The balls seem special.',
    'Then, Mike’s dad drives into the driveway. The game is over, but Tony is happy about finding the balls.',
    'The game is over, but Tony is happy about finding the balls.',
    'The soccer ball and basketball are in a tornado!',
    'Then, they are thrown onto a roof of a house at night.',
    'The next day, they hear someone coming onto the roof.',
    'It’s Tony!',
];

// export const HHT1_EP12_ANSWER_SOUNDS = [
//     '/1_EP12_SB_TL_18.mp3',
//     '/1_EP12_SB_TL_02.mp3',
//     '/1_EP12_SB_TL_03.mp3',
//     '/1_EP12_SB_TL_04.mp3',
//     '/1_EP12_SB_TL_05.mp3',
//     '/1_EP12_SB_TL_06.mp3',
//     '/1_EP12_SB_TL_07.mp3',
//     '/1_EP12_SB_TL_08.mp3',
//     '/1_EP12_SB_TL_09.mp3',
//     '/1_EP12_SB_TL_10.mp3',
//     '/1_EP12_SB_TL_11.mp3',
//     '/1_EP12_SB_TL_12.mp3',
//     '/1_EP12_SB_TL_13.mp3',
//     '/1_EP12_SB_TL_14.mp3',
//     '/1_EP12_SB_TL_15.mp3',
//     '/1_EP12_SB_TL_16.mp3',
//     '/1_EP12_SB_TL_17.mp3',
//     '/1_EP12_SB_TL_01.mp3',
//     '/1_EP12_SB_TL_19.mp3',
//     '/1_EP12_SB_TL_20.mp3',
//     '/1_EP12_SB_TL_21.mp3',
// ];

export const HHT1_EP12_ANSWER_SOUNDS = [
    '/057bfffad6ec85be6a311b95e32697f1.mp3',
    '/db65e61ffed674e6ac36642edcd9d8f7.mp3',
    '/ad351190888229533636e2d7d40b0764.mp3',
    '/55eb7d996f3865e4a3ecf22bcab064e7.mp3',
    '/c543c555a77a15cab44e5daa1323ed83.mp3',
    '/fdb280ecb30ed5b1a229a3120b4a5912.mp3',
    '/f099d7049bc7c5f2789ca9b8ef73edf4.mp3',
    '/7440b37b72586bb238bdcf785e0c78fd.mp3',
    '/887b2ed7cedd1309e700bf55b64368c2.mp3',
    '/9952ee721bd28cf03aa6c27a43c86ee1.mp3',
    '/44bd1d9ae3eb18749cc8f1ad61de1c5e.mp3',
    '/4d17fdf78a2e5c0d85359bf6f8331e5a.mp3',
    '/577e9388772589f400a5b1fe534082cd.mp3',
    '/a1bf45c0b3022e8bd8e9f8f1ff6e75c2.mp3',
    '/b7fc7641903e3c28f0373db3ae8a4634.mp3',
    '/ccaf18e19da72c99ff5d53acac579a14.mp3',
    '/05d6e1babd817c9f33bf4f28fb12d4a4.mp3',
    '/665038739a4d3b47255d45054d1f1858.mp3',
    '/ca8735a22e1388be92c8737ee8369068.mp3',
    '/eb4a2090a9859949bcaa17b073bbd2f9.mp3',
    '/edd02c887c0d368c65191d1b7308151d.mp3',
];


export const HHT1_EP12_QUIZ_ITEMS = [{
    'A': HHT1_EP12_ANSWERS[2],
    'B': HHT1_EP12_ANSWERS[14],
    'SoundIndexA': 2,
    'SoundIndexB': 14,
    'answer': HHT1_EP12_ANSWERS[2],
    'sound': [3],
    'exception': false,
},
    {
        'A': HHT1_EP12_ANSWERS[16],
        'B': HHT1_EP12_ANSWERS[4],
        'SoundIndexA': 16,
        'SoundIndexB': 4,
        'answer': HHT1_EP12_ANSWERS[4],
        'sound': [5],
        'exception': false,
    },
    {
        'A': HHT1_EP12_ANSWERS[6],
        'B': HHT1_EP12_ANSWERS[0],
        'SoundIndexA': 6,
        'SoundIndexB': 17,
        'answer': HHT1_EP12_ANSWERS[6],
        'sound': [18, 19],
        'exception': false,
    },
    {
        'A': HHT1_EP12_ANSWERS[3],
        'B': HHT1_EP12_ANSWERS[11],
        'SoundIndexA': 3,
        'SoundIndexB': 20,
        'answer': HHT1_EP12_ANSWERS[11],
        'sound': [13, 14],
        'exception': true,
    },
    {
        'A': HHT1_EP12_ANSWERS[15],
        'B': HHT1_EP12_ANSWERS[5],
        'SoundIndexA': 15,
        'SoundIndexB': 5,
        'answer': HHT1_EP12_ANSWERS[15],
        'sound': [16],
        'exception': false,
    },

]
